export const googleMapsSearchByTextRequest = async (
  query: string,
): Promise<google.maps.places.Place[]> => {
  const request: google.maps.places.SearchByTextRequest = {
    textQuery: query,
    fields: ["addressComponents"],
  };

  const { Place } = (await google.maps.importLibrary(
    "places",
  )) as google.maps.PlacesLibrary;

  const { places } = await Place.searchByText(request);

  return places;
};
